/* ==========================================================================
   Oma Nimitarra effects (assets/fx.js)
   Progressive enhancement only: nothing here is needed to read or buy.
   Everything respects prefers-reduced-motion and the "enable motion" theme setting (html.nl-motion).
   Modules: hero demo (the stickers show other names until the visitor types), hero parallax,
            magnetic buttons, confetti (free shipping reached).
   ========================================================================== */
(function () {
  'use strict';

  var root = document.documentElement;
  var mq = function (q) { return !!(window.matchMedia && window.matchMedia(q).matches); };
  var reduce = mq('(prefers-reduced-motion: reduce)');
  var motion = root.classList.contains('nl-motion') && !reduce;
  var finePointer = mq('(hover: hover) and (pointer: fine)');

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function trim(s) { return String(s).replace(/^\s+|\s+$/g, ''); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  /* ---------- Hero demo: the stickers try other names and designs until the visitor takes over ----------------- */

  // What each round shows: the main sticker (and the sheet and the squirrel's collar) in one of the designs of the chips under the form,
  // the sports label with another sport, another number and another name, the small label with another animal and another name.
  // At any moment the three stickers have three different names and three different designs, so nothing repeats (no two unicorns).
  var DEMO_SPORTS = [['jalkapallo', '11'], ['koripallo', '23'], ['jaakiekko', '19'], ['jalkapallo', '7'], ['koripallo', '5'], ['jaakiekko', '91'], ['jalkapallo', '10'], ['koripallo', '30']];
  var DEMO_MINI = ['kettu', 'koira', 'raketti', 'aurinko', 'kaktus', 'yksisarvinen', 'dinosaurus'];

  function heroDemo() {
    if (!motion) return;
    var el = $('[data-live-name][data-autoplay]');
    if (!el) return;
    var api = el.nlLive;
    var S = window.OmaSticker;
    if (!api || !S || !S.designById) return;

    var names = (el.getAttribute('data-autoplay-names') || '').split(',').map(trim).filter(Boolean);
    if (names.length < 2) return;
    // A design can be drawn when it exists and its art is already on the page; the dark "stylish" ones are not for the demo
    function drawable(id) {
      var d = S.designById(id);
      return !!d && d.g !== 'tyylikkaat' && (!d.a || !!S.art[d.a]);
    }
    var designs = $$('[data-live-design]', el).map(function (b) { return b.getAttribute('data-live-design'); }).filter(drawable);
    if (!designs.length) return;
    var sports = DEMO_SPORTS.filter(function (s) { return drawable(s[0]); });
    var minis = DEMO_MINI.filter(drawable);
    var input = api.input;

    // Names are dealt so that one design (and one sport, and one animal) meets girls' and boys' names in turn and every name comes round
    // evenly (Oscar 20.10.2026: the unicorn only ever had boys' names, the shark and the dinosaur only girls'; the old rule took the name
    // from the round number, which tied the design to the name's place in the list). The names are listed girl, boy, girl, boy ...: the
    // even places are one group, the odd places the other. Each round the main sticker takes a name from the group its design has met less
    // often, the sports label one from the other group and the small label one from the main sticker's group, so every round shows both kinds
    // of names, no two stickers share a name, and the small label never keeps the animal it had in the round before.
    var groups = [[], []];
    names.forEach(function (nm, k) { groups[k % 2].push(nm); });
    var tally = {};
    function seen(key) { return tally[key] || 0; }
    function last(key) { return tally['@' + key] || 0; }
    function bump(key, at) { tally[key] = seen(key) + 1; tally['@' + key] = at; }
    // the first of the items with the lowest score (a score is a list, compared place by place)
    function lowest(items, score) {
      var best, bestScore;
      items.forEach(function (it) {
        var s = score(it), better = bestScore === undefined;
        for (var k = 0; !better && k < s.length; k++) {
          if (s[k] !== bestScore[k]) { better = s[k] < bestScore[k]; break; }
        }
        if (better) { best = it; bestScore = s; }
      });
      return best;
    }
    // the group a category (a design, a sport, an animal) has met less often; the first time it is the preferred one
    function groupFor(cat, prefer) {
      var a = seen('g:' + cat + ':0'), b = seen('g:' + cat + ':1');
      return a === b ? prefer : (a < b ? 0 : 1);
    }
    // a name of the group that this category has met least (then the one shown least often and longest ago), none of the names in avoid
    function nameFrom(group, cat, avoid, at) {
      var nm = lowest(groups[group].filter(function (x) { return avoid.indexOf(x) < 0; }), function (x) {
        return [seen('n:' + cat + ':' + x), seen('u:' + x), last('u:' + x)];
      });
      if (nm) { bump('n:' + cat + ':' + nm, at); bump('u:' + nm, at); }
      return nm || '';
    }
    var kinds = [];                                    // the sports with their numbers: football 11, 7, 10 ...
    sports.forEach(function (s) {
      var kind = kinds.filter(function (x) { return x.id === s[0]; })[0];
      if (!kind) { kind = { id: s[0], numbers: [] }; kinds.push(kind); }
      kind.numbers.push(s[1]);
    });
    // The name in the markup (Aino with the shark) counts as the round before the first
    var startName = trim(el.getAttribute('data-default-name') || ''), startDesign = el.getAttribute('data-default-design') || '';
    var startAt = names.indexOf(startName);
    if (startAt >= 0 && designs.indexOf(startDesign) >= 0) {
      bump('g:d:' + startDesign + ':' + (startAt % 2), 0);
      bump('n:d:' + startDesign + ':' + startName, 0);
      bump('u:' + startName, 0);
    }

    var lastMini = '', lastMain = trim(el.getAttribute('data-default-name') || '');
    function round(i) {
      var main = designs[i % designs.length];
      var gMain = groupFor('d:' + main, (i % designs.length) % 2);
      bump('g:d:' + main + ':' + gMain, i);
      var nameMain = nameFrom(gMain, 'd:' + main, [lastMain], i) || nameFrom(gMain, 'd:' + main, [], i);   // never the name of the round before
      lastMain = nameMain;
      var used = [nameMain], per = {};

      // the sports label: the other group, and the sport that has met that group the least
      var kind = lowest(kinds, function (k) { return [seen('g:s:' + k.id + ':' + (1 - gMain)), last('s:' + k.id)]; });
      if (kind) {
        var nameSport = nameFrom(1 - gMain, 's:' + kind.id, used, i);
        if (nameSport) {
          used.push(nameSport);
          bump('g:s:' + kind.id + ':' + (1 - gMain), i);
          bump('s:' + kind.id, i);
          per['.hero__sticker--oblong'] = { text: nameSport, design: kind.id, text2: kind.numbers[seen('k:' + kind.id) % kind.numbers.length] };
          bump('k:' + kind.id, i);
        }
      }

      // the small label: the main sticker's group, and the animal that has met that group the least
      var animal = lowest(minis.filter(function (c) { return c !== main && c !== lastMini && (!kind || c !== kind.id); }), function (c) {
        return [seen('g:a:' + c + ':' + gMain), last('a:' + c)];
      });
      lastMini = animal || '';
      if (animal) {
        var nameMini = nameFrom(gMain, 'a:' + animal, used, i);
        if (nameMini) {
          bump('g:a:' + animal + ':' + gMain, i);
          bump('a:' + animal, i);
          per['.hero__sticker--mini'] = { text: nameMini, design: animal };
        }
      }
      return { name: nameMain, design: main, per: per };
    }

    // The placeholder follows the demo name: "Kirjoita nimi, esim. Aino" -> "... esim. Eetu"
    var fallbackName = el.getAttribute('data-default-name') || '';
    var basePh = input ? input.getAttribute('placeholder') || '' : '';
    var phHead = fallbackName && basePh.slice(-fallbackName.length) === fallbackName ? basePh.slice(0, basePh.length - fallbackName.length) : null;

    var i = 0, timer = 0, stopped = false, onScreen = true;

    function tick() {
      timer = 0;
      if (stopped) return;
      if (onScreen && !document.hidden) {
        i++;
        var r = round(i);
        api.show(r.name, r.design, r.per);
        if (input && phHead !== null) input.setAttribute('placeholder', phHead + r.name);
      }
      timer = setTimeout(tick, 2900);
    }
    function stop() {
      if (stopped) return;
      stopped = true;
      clearTimeout(timer);
      if (input && phHead !== null) input.setAttribute('placeholder', basePh);
      // The visitor takes over: the labels go back to the plain example, the chosen design stays
      if (api.reset) api.reset();
    }

    if (input) {
      input.addEventListener('focus', stop);
      input.addEventListener('input', stop);
    }
    $$('[data-live-design]', el).forEach(function (b) { b.addEventListener('click', stop); });
    var form = $('form', el);
    if (form) form.addEventListener('pointerdown', stop);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { onScreen = entries[0].isIntersecting; }, { threshold: 0.2 }).observe(el);
    }
    timer = setTimeout(tick, 3200);
  }

  /* ---------- Hero parallax: the stage layers drift with the pointer, the sheet tilts a little ------------------- */

  function heroParallax() {
    if (!motion || !finePointer) return;
    var stage = $('.hero__stage');
    var panel = stage && stage.closest('.hero__panel');
    if (!panel) return;
    var nx = 0, ny = 0, raf = 0;
    function apply() {
      raf = 0;
      stage.style.setProperty('--px', nx.toFixed(3));
      stage.style.setProperty('--py', ny.toFixed(3));
    }
    panel.addEventListener('pointermove', function (e) {
      var r = stage.getBoundingClientRect();
      nx = clamp(((e.clientX - r.left) / r.width - 0.5) * 2, -1, 1);
      ny = clamp(((e.clientY - r.top) / r.height - 0.5) * 2, -1, 1);
      if (!raf) raf = requestAnimationFrame(apply);
    }, { passive: true });
    panel.addEventListener('pointerleave', function () { nx = 0; ny = 0; apply(); });
    stage.classList.add('is-parallax');
  }

  /* ---------- Magnetic buttons: the big call to action leans toward the pointer ----------------------------------- */

  function magnets() {
    if (!motion || !finePointer) return;
    $$('[data-magnet]').forEach(function (b) {
      var raf = 0, tx = 0, ty = 0;
      function apply() { raf = 0; b.style.setProperty('--mx', tx.toFixed(1) + 'px'); b.style.setProperty('--my', ty.toFixed(1) + 'px'); }
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        tx = clamp((e.clientX - (r.left + r.width / 2)) * 0.18, -9, 9);
        ty = clamp((e.clientY - (r.top + r.height / 2)) * 0.28, -6, 6);
        if (!raf) raf = requestAnimationFrame(apply);
      }, { passive: true });
      b.addEventListener('pointerleave', function () { tx = 0; ty = 0; apply(); });
    });
  }

  /* ---------- Confetti: a few little stickers pop out of a button (add to cart, free shipping reached) ------------- */

  var CONFETTI = ['#FFE46B', '#F6C5D0', '#A9D8EA', '#35BF9A', '#FFFFFF', '#0A7F5F'];

  window.NLConfetti = function (origin, count) {
    if (!motion || !origin || !origin.getBoundingClientRect || !document.body.animate) return;
    var r = origin.getBoundingClientRect();
    var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
    var n = count || 16;
    var layer = document.createElement('div');
    layer.className = 'confetti';
    layer.setAttribute('aria-hidden', 'true');
    document.body.appendChild(layer);
    var done = 0;
    for (var i = 0; i < n; i++) {
      var p = document.createElement('span');
      var round = i % 3 === 0;
      var size = 7 + Math.random() * 8;
      p.className = 'confetti__bit' + (round ? ' confetti__bit--round' : '');
      p.style.cssText = 'left:' + cx + 'px;top:' + cy + 'px;width:' + (round ? size : size * 1.7) + 'px;height:' + size + 'px;background:' + CONFETTI[i % CONFETTI.length];
      layer.appendChild(p);
      var angle = (-Math.PI / 2) + (Math.random() - 0.5) * Math.PI * 1.25;
      var dist = 70 + Math.random() * 120;
      var dx = Math.cos(angle) * dist, dy = Math.sin(angle) * dist;
      var rot = (Math.random() - 0.5) * 540;
      var a = p.animate([
        { transform: 'translate(-50%,-50%) scale(0.4) rotate(0deg)', opacity: 1, offset: 0 },
        { transform: 'translate(' + (dx - 50) + 'px,' + (dy - 50) + 'px) scale(1) rotate(' + rot * 0.6 + 'deg)', opacity: 1, offset: 0.55 },
        { transform: 'translate(' + (dx * 1.12 - 50) + 'px,' + (dy + 120) + 'px) scale(0.9) rotate(' + rot + 'deg)', opacity: 0, offset: 1 }
      ], { duration: 900 + Math.random() * 500, easing: 'cubic-bezier(0.2, 0.7, 0.3, 1)', fill: 'forwards' });
      a.onfinish = function () { if (++done === n) layer.remove(); };
    }
  };

  // Free shipping reached: the sticker on the progress bar pops confetti (once, when the cart crosses the line)
  var shippingDone = !!$('.cart-drawer .cart-progress.is-done, [data-cart-page] .cart-progress.is-done');
  document.addEventListener('cart:updated', function (e) {
    var cart = e.detail || {};
    var line = (window.NL && window.NL.shipping && window.NL.shipping.threshold) || 0;
    var done = line > 0 && cart.item_count > 0 && cart.total_price >= line;
    if (done && !shippingDone) {
      setTimeout(function () {
        var bar = $$('[data-cart-progress]').filter(function (n) {
          var r = n.getBoundingClientRect();
          return r.width > 0 && window.getComputedStyle(n).visibility === 'visible';
        })[0];
        if (bar) window.NLConfetti($('.cart-progress__mark', bar) || bar, 22);
      }, 700);
    }
    shippingDone = done;
  });

  /* ---------- Boot ----------------------------------------------------------------------------------------------- */

  function boot() {
    heroDemo();
    heroParallax();
    magnets();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor: sections that were re-rendered
  document.addEventListener('shopify:section:load', function () { magnets(); });
})();
